import React from "react";
import { Popup, Position, ToolbarItem } from "devextreme-react/popup";
import Loader from "./Loader";

const WarningModal = ({ visible, text, id, handleYes, handleNo, ready }) => {
  return (
    <Popup
      visible={!!visible}
      closeOnOutsideClick={false}
      showCloseButton={false}
      showTitle={true}
      title="Delete"
      container=".dx-viewport"
      width={400}
      height={200}
    >
      {!ready && <Loader />}
      <Position at="center" my="center" />
      <ToolbarItem
        widget="dxButton"
        toolbar="bottom"
        location="before"
        options={{
          icon: "check",
          text: "Yes",
          onClick: handleYes,
        }}
      />
      <ToolbarItem
        widget="dxButton"
        toolbar="bottom"
        location="after"
        options={{
          icon: "close",
          text: "No",
          onClick: handleNo,
        }}
      />
      <p>{`${text} with id: ${id}`}</p>
    </Popup>
  );
};

export default WarningModal;
